// import React from "react";
// import { Splide, SplideSlide } from "@splidejs/react-splide";

// import "@splidejs/react-splide/css";
// //
// // or other themes
// // import '@splidejs/react-splide/css/skyblue';
// import "@splidejs/react-splide/css/sea-green";
// import { Box, Container } from "@mui/material";

// // or only core styles
// // import '@splidejs/react-splide/css/core';

// const Carousel = (props) => {
//   return (
//     <>
//       <Box
//         sx={{
//           display: {
//             xs: "none",
//             sm: "none",
//             md: "none",
//             lg: "none",
//             xl: "flex",
//           },
//         }}
//         className="carousel-wrapper"
//       >
//         <Splide
//           options={{
//             rewind: true,
//             perPage: props.slideCount || 4,
//             perMove: 1,
//           }}
//           aria-label="My Favorite Images"
//         >
//           {props.children.map((child) => {
//             return <SplideSlide>{child}</SplideSlide>;
//           })}
//         </Splide>
//       </Box>
//       <Container maxWidth="xl">
//         <Box
//           sx={{
//             display: {
//               xs: "none",
//               sm: "none",
//               md: "none",
//               lg: "flex",
//               xl: "none",
//             },
//           }}
//           className="carousel-wrapper"
//         >
//           <Splide
//             options={{
//               rewind: true,
//               perPage: props.slideCount || 5,
//               perMove: 1,
//             }}
//             aria-label="My Favorite Images"
//           >
//             {props.children.map((child) => {
//               return <SplideSlide>{child}</SplideSlide>;
//             })}
//           </Splide>
//         </Box>
//       </Container>
//       <Box
//         sx={{
//           display: {
//             xs: "none",
//             sm: "flex",
//             md: "flex",
//             lg: "none",
//             xl: "none",
//           },
//         }}
//         className="carousel-wrapper"
//       >
//         <Splide
//           options={{
//             rewind: true,
//             perPage: 2,
//             perMove: 1,
//           }}
//           aria-label="My Favorite Images"
//         >
//           {props.children.map((child) => {
//             return <SplideSlide>{child}</SplideSlide>;
//           })}
//         </Splide>
//       </Box>
//       <Box
//         sx={{
//           display: {
//             xs: "flex",
//             sm: "none",
//             md: "none",
//             lg: "none",
//             xl: "none",
//           },
//         }}
//         className="carousel-wrapper"
//       >
//         <Splide
//           options={{
//             rewind: true,
//             perPage: 1,
//             perMove: 1,
//           }}
//           aria-label="My Favorite Images"
//         >
//           {props.children.map((child) => {
//             return <SplideSlide>{child}</SplideSlide>;
//           })}
//         </Splide>
//       </Box>
//     </>
//   );
// };

// export default Carousel;
// import React from "react";
// import { Splide, SplideSlide } from "@splidejs/react-splide";
// import "@splidejs/react-splide/css";
// import { Box, useTheme, useMediaQuery } from "@mui/material";

// const Carousel = ({ children }) => {
//   const theme = useTheme();

//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));          // xs
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg")); // sm + md
//   const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));           // lg+

//   const perPage = isMobile ? 2 : isTablet ? 3 : 5; // ✅ desktop=5, tab=3

//   return (
//     <Box className="carousel-wrapper">
//       <Splide
//         options={{
//           rewind: true,
//           perPage,
//           perMove: 1,
//           gap: "1rem",
//           arrows: !isMobile,
//           pagination: isMobile,
//           drag: true,
//           breakpoints: {
//             600: { gap: "0.75rem" },
//             1024: { gap: "1rem" },
//           },
//         }}
//         aria-label="Product Carousel"
//       >
//         {React.Children.map(children, (child, index) => (
//           <SplideSlide key={index}>{child}</SplideSlide>
//         ))}
//       </Splide>
//     </Box>
//   );
// };

// export default Carousel;

import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { Box, useTheme, useMediaQuery } from "@mui/material";

const Carousel = ({ children }) => {
  const theme = useTheme();

  // Only hide on real mobile
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  if (isMobile) return null;

  return (
    <Box className="carousel-wrapper">
      <Splide
        options={{
          type: "slide",
          rewind: true,

          perPage: "auto", // 🔥 auto-fit cards
          focus: 0, // 🔥 required for arrows

          gap: "1rem",
          perMove: 1,

          arrows: true, // 🔥 force arrows
          pagination: false,
          drag: true,

          speed: 200,
        }}
      >
        {React.Children.map(children, (child, index) => (
          <SplideSlide key={index}>
            <div
              className="slide-item"
              style={{
                width: isDesktop ? "210px" : "220px", // 🔥 fixed card size
              }}
            >
              {child}
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </Box>
  );
};

export default Carousel;
